import React, { Component, Fragment } from "react";
import { Divider, Typography, Button, Tooltip } from "@material-ui/core";
import Swal from "sweetalert2";
import Chart from "react-apexcharts";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

import CustomDialog from "../../../layout/CustomDialog";
import LabeledTextField from "../../../layout/LabeledTextField";

// Original optional props:
// open
// onClose

// Extended optional props:
// handleResults - force the result.
// iazamCombinationPercent

class HasMutavTzinunDialog extends Component {
  state = {
    helpCalculationButtonClicked: false,
    isChecked: false,

    groundUnitPrice: null,
    amountOfUnitsInProject: null,
    projectBuildingCost: null,

    totalBuildingArea: null,
    buildingCostPerSquareMeter: null,
    totalProjectDevelopmentCost: null,
    architectCost: null,
    engineerCost: null,
    advisersCost: null,
    improvementLevy: null,
    constructionFee: null,
    developmentFee: null,
    evacuationCost: null,
    rentCost: null,
    depreciationAmount: null,
    profitPercent: null,
    unplannedPercent: null,
    outcomes: [],

    exchangeByZaban: null,
    exchangeByGroundUnits: null,

    iazamCombinationPercent: this.props.iazamCombinationPercent || 0,
    valueActualSoldOfProperty: null
  };

  render() {
    const ownersPercent = 100 - (this.state.iazamCombinationPercent || 0);
    const iazamPercent = this.state.iazamCombinationPercent || 0;

    return (
      <CustomDialog
        label="מחשבון עזר לחישוב שווי עסקת קומבינציה"
        open={this.props.open}
        onClose={this.props.onClose}
        maxWidth="md"
        paperClassName="deal-calc-dialog combination-dialog"
      >
        <div className="combination-dialog-body">
          <div className="combination-dialog-top">
            <div className="combination-dialog-fields">
              <LabeledTextField
                type="number"
                label="מחיר יחידת קרקע"
                name="groundUnitPrice"
                labelWidth={280}
                textFieldWidth={140}
                onChange={(e) => this.handleOnChange(e)}
                value={this.state.groundUnitPrice}
              />
              <LabeledTextField
                type="number"
                label="מספר יחידות במיזם כולו"
                name="amountOfUnitsInProject"
                labelWidth={280}
                textFieldWidth={140}
                onChange={(e) => this.handleOnChange(e)}
                value={this.state.amountOfUnitsInProject}
              />
              <LabeledTextField
                disabled={this.state.helpCalculationButtonClicked}
                type="number"
                label='עלות בנית הפרויקט כולל מע"מ (לפי דוח 0)'
                name="projectBuildingCost"
                labelWidth={280}
                textFieldWidth={140}
                onChange={(e) => this.handleOnChange(e)}
                value={this.state.projectBuildingCost}
              />
              <Button
                className="combination-dialog-help-btn"
                variant="outlined"
                endIcon={
                  this.state.helpCalculationButtonClicked ? (
                    <ArrowDownwardIcon style={{ marginRight: "8px" }} />
                  ) : (
                    <ArrowBackIcon style={{ marginRight: "8px" }} />
                  )
                }
                onClick={() => this.handleHelpCalculation()}
              >
                עזרה בחישוב עלות הפרויקט
              </Button>
              {this.state.helpCalculationButtonClicked ? (
                <Fragment>
                  <LabeledTextField
                    type="number"
                    label='שטח בניה ברוטו של כל הפרויקט במ"ר'
                    name="totalBuildingArea"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.totalBuildingArea}
                  />
                  <LabeledTextField
                    type="number"
                    label='עלות בניה למ"ר כולל מע"מ (חומר ועבודה)'
                    name="buildingCostPerSquareMeter"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.buildingCostPerSquareMeter}
                  />
                  <LabeledTextField
                    type="number"
                    label="עלות פיתוח של כל הפרויקט"
                    name="totalProjectDevelopmentCost"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.totalProjectDevelopmentCost}
                  />
                  <Typography className="combination-dialog-section-title" variant="subtitle1">
                    עלות תכנון של כל הפרויקט:
                  </Typography>
                  <LabeledTextField
                    type="number"
                    label="אדריכל"
                    name="architectCost"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.architectCost}
                  />
                  <LabeledTextField
                    type="number"
                    label="מהנדס"
                    name="engineerCost"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.engineerCost}
                  />
                  <LabeledTextField
                    type="number"
                    label="יתר היועצים"
                    name="advisersCost"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.advisersCost}
                  />
                  <Typography className="combination-dialog-section-title" variant="subtitle1">
                    אגרות, מיסים והיטלים של כל הפרויקט:
                  </Typography>
                  <LabeledTextField
                    type="number"
                    label="היטל השבחה"
                    name="improvementLevy"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.improvementLevy}
                  />
                  <LabeledTextField
                    type="number"
                    label="אגרת בניה"
                    name="constructionFee"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.constructionFee}
                  />
                  <LabeledTextField
                    type="number"
                    label="אגרת פיתוח"
                    name="developmentFee"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.developmentFee}
                  />
                  <Typography className="combination-dialog-section-title" variant="subtitle1">
                    תשלום מזומן ע"י הקונה (הקבלן) שנוסף לשווי הבניה:
                  </Typography>
                  <LabeledTextField
                    type="number"
                    label="עלות פינוי בעל הקרקע"
                    name="evacuationCost"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.evacuationCost}
                  />
                  <LabeledTextField
                    type="number"
                    label='שכ"ד בעל הקרקע לתקופת הבניה'
                    name="rentCost"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.rentCost}
                  />
                  <Typography className="combination-dialog-section-title" variant="subtitle1">
                    תשלום מזומן ע"י המוכר בעל הקרקע (יופחת משווי הבניה):
                  </Typography>
                  <LabeledTextField
                    type="number"
                    label="הסכום שיופחת"
                    name="depreciationAmount"
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.depreciationAmount}
                  />
                  <Typography className="combination-dialog-section-title" variant="subtitle1">
                    הוצאות נוספות:
                  </Typography>
                  <LabeledTextField
                    type="number"
                    label="רווח קבלני לכל הפרויקט ב%"
                    name="profitPercent"
                    min={0}
                    max={100}
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.profitPercent}
                  />
                  <LabeledTextField
                    type="number"
                    label='בלת"מ ב%'
                    name="unplannedPercent"
                    min={0}
                    max={100}
                    labelWidth={280}
                    textFieldWidth={140}
                    onChange={(e) => this.handleOnChange(e)}
                    value={this.state.unplannedPercent}
                  />
                  <div className="combination-dialog-outcomes-header">
                    <Typography variant="subtitle1">להוספת הוצאות נוספות</Typography>
                    <Tooltip title="הוספה">
                      <Button
                        className="combination-dialog-add-btn"
                        variant="contained"
                        aria-label="הוספה"
                        onClick={() => this.addOutcome()}
                      >
                        <AddIcon fontSize="small" />
                      </Button>
                    </Tooltip>
                  </div>
                  {this.state.outcomes.map((outcome, index) => {
                    return (
                      <div className="combination-dialog-outcome-row" key={`outcome-${index}`}>
                        <LabeledTextField
                          type="number"
                          label="סכום ההוצאה"
                          name="amount"
                          labelWidth={100}
                          textFieldWidth={140}
                          onChange={(e) => this.handleOutcomeOnChange(e, index)}
                          value={outcome.amount}
                        />
                        <LabeledTextField
                          type="number"
                          label="אחוז ההוצאה"
                          name="percent"
                          min={0}
                          max={100}
                          labelWidth={100}
                          textFieldWidth={140}
                          onChange={(e) => this.handleOutcomeOnChange(e, index)}
                          value={outcome.percent}
                          currency="%"
                        />
                        <Tooltip title="מחיקה">
                          <DeleteIcon
                            className="combination-dialog-delete-icon"
                            fontSize="small"
                            onClick={() => this.removeOutcome(index)}
                          />
                        </Tooltip>
                      </div>
                    );
                  })}
                </Fragment>
              ) : null}
            </div>

            <aside className="combination-dialog-aside">
              <div className="combination-dialog-percent">
                <LabeledTextField
                  type="number"
                  label="לשינוי האחוז הנמכר ליזם"
                  name="iazamCombinationPercent"
                  min={1}
                  max={99}
                  labelWidth={170}
                  textFieldWidth={72}
                  onChange={(e) => this.handleOnChange(e)}
                  value={this.state.iazamCombinationPercent}
                  currency="%"
                />
              </div>
              <div className="combination-dialog-pie">
                <Chart
                  options={{
                    chart: {
                      dropShadow: {
                        enabled: true,
                        color: "#1e3d66",
                        top: 6,
                        left: 0,
                        blur: 10,
                        opacity: 0.2
                      },
                      fontFamily: "inherit"
                    },
                    labels: ["בעלים", "יזם"],
                    colors: ["#24558d", "#ffb109"],
                    fill: {
                      type: "gradient",
                      gradient: {
                        shade: "light",
                        type: "vertical",
                        shadeIntensity: 0.4,
                        gradientToColors: ["#173a68", "#ff9800"],
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                      }
                    },
                    stroke: {
                      colors: ["#ffffff"],
                      width: 3
                    },
                    dataLabels: {
                      style: {
                        colors: ["#ffffff"],
                        fontSize: "15px",
                        fontWeight: 500
                      },
                      dropShadow: {
                        blur: 3,
                        color: "#000000",
                        enabled: true,
                        opacity: 0.5
                      }
                    },
                    legend: {
                      fontSize: "14px",
                      fontWeight: 700,
                      horizontalAlign: "center",
                      labels: { colors: "#1e3d66" },
                      markers: { height: 11, radius: 11, width: 11 },
                      position: "bottom"
                    },
                    tooltip: {
                      y: {
                        formatter: (value) => `${Number(value).toFixed(1)}%`
                      }
                    },
                    plotOptions: {
                      pie: {
                        expandOnClick: false,
                        dataLabels: {
                          offset: 0,
                          minAngleToShowLabel: 8
                        }
                      }
                    }
                  }}
                  series={[ownersPercent, iazamPercent]}
                  type="pie"
                  width={260}
                />
              </div>
            </aside>
          </div>

          <div className="combination-dialog-calc-action">
            <Button className="combination-dialog-primary-btn" variant="contained" onClick={() => this.calculateCombination()}>
              לחץ לחישוב
            </Button>
          </div>

          <div className="combination-dialog-results">
            <div className="combination-dialog-result">
              <Typography className="combination-dialog-result-label" variant="subtitle1">
                התמורה לפי זכויות בניה
              </Typography>
              <LabeledTextField type="number" name="exchangeByZaban" disabled textFieldWidth={140} value={this.state.exchangeByZaban} />
            </div>
            <Divider className="combination-dialog-results-divider" orientation="vertical" flexItem />
            <div className="combination-dialog-result">
              <Typography className="combination-dialog-result-label" variant="subtitle1">
                התמורה לפי יחידת קרקע
              </Typography>
              <LabeledTextField
                type="number"
                name="exchangeByGroundUnits"
                disabled
                textFieldWidth={140}
                value={this.state.exchangeByGroundUnits}
              />
            </div>
          </div>

          {this.state.isChecked ? (
            <div className="combination-dialog-update">
              <LabeledTextField
                type="number"
                label="נא רשום את הסכום של שווי הקומבינציה:"
                name="valueActualSoldOfProperty"
                labelWidth={270}
                textFieldWidth={160}
                onChange={(e) => this.handleOnChange(e)}
                value={this.state.valueActualSoldOfProperty}
                currency="₪"
              />
              <Button className="combination-dialog-primary-btn" variant="contained" onClick={() => this.updateChanges()}>
                עדכן תמורה
              </Button>
            </div>
          ) : null}
        </div>
      </CustomDialog>
    );
  }

  calculateCombination() {
    if (!this.state.iazamCombinationPercent) {
      return Swal.fire("", "האחוז הנמכר ליזם הינו שדה חובה", "error");
    }
    if (!this.state.groundUnitPrice) {
      return Swal.fire("", "מחיר יחידת קרקע הינו שדה חובה", "error");
    }
    if (!this.state.amountOfUnitsInProject) {
      return Swal.fire("", "מספר יחידות במיזם כולו הינו שדה חובה", "error");
    }
    if (!this.state.helpCalculationButtonClicked && !this.state.projectBuildingCost) {
      return Swal.fire("", 'עלות בנית הפרויקט כולל מע"מ הינו שדה חובה', "error");
    }
    if (this.state.helpCalculationButtonClicked && !this.state.totalBuildingArea) {
      return Swal.fire("", 'שטח בניה ברוטו של כל הפרויקט במ"ר הינו שדה חובה', "error");
    }
    if (this.state.helpCalculationButtonClicked && !this.state.buildingCostPerSquareMeter) {
      return Swal.fire("", 'עלות בניה למ"ר כולל מע"מ הינו שדה חובה', "error");
    }

    const exchangeByGroundUnits = Math.floor(
      this.state.amountOfUnitsInProject * this.state.groundUnitPrice * (this.state.iazamCombinationPercent / 100)
    );

    let exchangeByZaban;
    if (this.state.helpCalculationButtonClicked) {
      exchangeByZaban = this.state.totalBuildingArea * this.state.buildingCostPerSquareMeter;
      exchangeByZaban += this.state.totalProjectDevelopmentCost || 0;
      exchangeByZaban += this.state.architectCost || 0;
      exchangeByZaban += this.state.engineerCost || 0;
      exchangeByZaban += this.state.advisersCost || 0;
      exchangeByZaban += this.state.improvementLevy || 0;
      exchangeByZaban += this.state.constructionFee || 0;
      exchangeByZaban += this.state.developmentFee || 0;
      exchangeByZaban += this.state.evacuationCost || 0;
      exchangeByZaban += this.state.rentCost || 0;
      exchangeByZaban +=
        (exchangeByZaban * (this.state.profitPercent || 100)) / 100 + (exchangeByZaban * (this.state.unplannedPercent || 100)) / 100;
      exchangeByZaban *= 1 - this.state.iazamCombinationPercent / 100;
      exchangeByZaban -= this.state.depreciationAmount || 0;
      for (const outcome of this.state.outcomes) {
        if (outcome.amount && outcome.percent) {
          exchangeByZaban += outcome.amount * (outcome.percent / 100);
        }
      }
      exchangeByZaban = Math.floor(exchangeByZaban);
    } else {
      exchangeByZaban = this.state.projectBuildingCost;
      exchangeByZaban *= 1 - this.state.iazamCombinationPercent / 100;
      exchangeByZaban = Math.floor(exchangeByZaban);
    }

    this.setState({ exchangeByGroundUnits, exchangeByZaban, isChecked: true });
  }

  updateChanges() {
    if (!this.state.iazamCombinationPercent) {
      return Swal.fire("", "האחוז הנמכר ליזם הינו שדה חובה", "error");
    }
    if (!this.state.valueActualSoldOfProperty) {
      return Swal.fire("", "סכום שווי הקומבינציה הינו שדה חובה", "error");
    }
    if (this.props.handleResults) {
      const e1 = { target: { value: this.state.iazamCombinationPercent, name: "iazamCombinationPercent" } };
      const e2 = { target: { value: this.state.valueActualSoldOfProperty, name: "valueActualSoldOfProperty" } };
      this.props.handleResults(e1, e2);
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
    Swal.fire("נוסף לעסקה בהצלחה", "", "success");
  }

  handleOnChange(e) {
    const newState = { ...this.state, [e.target.name]: e.target.value };
    this.handleDependencies(e, newState);
    this.setState(newState);
  }

  handleDependencies(e, newState) {
    if (this.state.isChecked && e.target.name !== "valueActualSoldOfProperty") {
      newState.exchangeByGroundUnits = false;
      newState.exchangeByZaban = false;
      newState.isChecked = false;
    }
  }

  handleHelpCalculation() {
    this.setState({ helpCalculationButtonClicked: !this.state.helpCalculationButtonClicked, projectBuildingCost: null });
  }

  handleOutcomeOnChange(e, index) {
    const outcomes = [...this.state.outcomes];
    outcomes[index][e.target.name] = e.target.value;
    this.setState({ outcomes });
  }

  addOutcome() {
    const outcomes = [...this.state.outcomes];
    outcomes.push({ amount: null, percent: null });
    this.setState({ outcomes });
  }

  removeOutcome(index) {
    const outcomes = this.state.outcomes.filter((outcome, outcomeIndex) => outcomeIndex !== index);
    this.setState({ outcomes });
  }
}

export default HasMutavTzinunDialog;
